export const CREATE_MASTER_VACATION_RULE = "CREATE_MASTER_VACATION_RULE";
export const FETCH_MASTER_VACATION_RULES = "FETCH_MASTER_VACATION_RULES";
export const FETCH_MASTER_VACATION_RULE = "FETCH_MASTER_VACATION_RULE";
export const EDIT_MASTER_VACATION_RULE = "EDIT_MASTER_VACATION_RULE";
export const DELETE_MASTER_VACATION_RULE = "DELETE_MASTER_VACATION_RULE";
